import React, { FC, SVGProps } from 'react';

export const Rectangle: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58579 2.41421C8.36684 1.63316 9.63317 1.63317 10.4142 2.41421L15.5858 7.58579C16.3668 8.36684 16.3668 9.63317 15.5858 10.4142L10.4142 15.5858C9.63316 16.3668 8.36684 16.3668 7.58579 15.5858L2.41421 10.4142C1.63316 9.63316 1.63317 8.36684 2.41421 7.58579L7.58579 2.41421Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58579 2.41421C8.36684 1.63316 9.63317 1.63317 10.4142 2.41421L15.5858 7.58579C16.3668 8.36684 16.3668 9.63317 15.5858 10.4142L10.4142 15.5858C9.63316 16.3668 8.36684 16.3668 7.58579 15.5858L2.41421 10.4142C1.63316 9.63316 1.63317 8.36684 2.41421 7.58579L7.58579 2.41421Z"
      fill="#919393"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58579 2.41421C8.36684 1.63316 9.63317 1.63317 10.4142 2.41421L15.5858 7.58579C16.3668 8.36684 16.3668 9.63317 15.5858 10.4142L10.4142 15.5858C9.63316 16.3668 8.36684 16.3668 7.58579 15.5858L2.41421 10.4142C1.63316 9.63316 1.63317 8.36684 2.41421 7.58579L7.58579 2.41421Z"
      stroke="#919393"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
